import { render, staticRenderFns } from "./PrintMenuColorioNenga.vue?vue&type=template&id=76c43a2e&scoped=true&"
import script from "./PrintMenuColorioNenga.vue?vue&type=script&lang=js&"
export * from "./PrintMenuColorioNenga.vue?vue&type=script&lang=js&"
import style0 from "./PrintMenuColorioNenga.vue?vue&type=style&index=0&id=76c43a2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c43a2e",
  null
  
)

export default component.exports